/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import {$createLinkNode} from '@lexical/link';
import {$createListItemNode, $createListNode} from '@lexical/list';
import {LexicalComposer} from '@lexical/react/LexicalComposer';
import {$createHeadingNode, $createQuoteNode} from '@lexical/rich-text';
import {$createParagraphNode, $createTextNode, $getRoot} from 'lexical';
import {SettingsContext, useSettings} from './context/SettingsContext';
import Editor from './Editor';
import PlaygroundNodes from './nodes/PlaygroundNodes';
import PlaygroundEditorTheme from './themes/PlaygroundEditorTheme';
import "./index.css";


function App(props: any): JSX.Element {
  
  const {
    placeholder = "Bibliografía"
  } = props;

  const initialConfig = {
    editorState: null,
    namespace: 'Playground',
    nodes: [...PlaygroundNodes],
    onError: (error: Error) => {
      throw error;
    },
    theme: PlaygroundEditorTheme
  };


  return (
    <LexicalComposer initialConfig={initialConfig}> 

            <div className="editor-shell">
              <Editor
                handleEditorChange={props.handleEditorChange}
                content={props.content}
                htmlContent={props.htmlContent}
                preferHtml={props.preferHtml}
                emitHumanChangesOnly={props.emitHumanChangesOnly}
                disabled={props.disabled}
                placeholder={placeholder}
              />
            </div>
        
    </LexicalComposer>
  );
}

export default function PlaygroundApp(props: any): JSX.Element {

  const {
    placeholder = "Bibliografía"
  } = props;

  return (
    <SettingsContext>
      <App
        handleEditorChange={props.handleEditorChange}
        content={props.content}
        htmlContent={props.htmlContent}
                preferHtml={props.preferHtml}
                emitHumanChangesOnly={props.emitHumanChangesOnly}
                disabled={props.disabled}
        placeholder={placeholder}
      />
    </SettingsContext>
  );
}

